import React from 'react';
import "./navbar.css";
import {Link} from "react-router-dom";
const Navbar = () => {
   

    return (
        <div className="navbarr">
            <div className="logo">
                
                <h3><Link to="/">EcoWaste</Link></h3>
            </div>
            
           <ul>
            <li><Link to="/Services">Services</Link></li>
            <li><Link to="/About">About</Link></li>
            <li><Link to="/Sustainability">Sustainability</Link></li>
            <li><Link to="/Products">Products</Link></li>
            <li><Link to="/login">Login</Link></li>
           </ul>
           
        </div>
    );
};

export default Navbar;